import React, { Fragment, useCallback, useState } from 'react';
import DataTable from 'react-data-table-component';

import { Btn, H4, Image } from '../../../AbstractElements';
import { dummytabledata, tableColumns } from '../../../Data/Table/Defaultdata';

const DataTableComponent = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);

  const updatedData = dummytabledata.map((item) => ({
    ...item,
    name: (
      <div className='d-flex'>
        <Image className='rounded-circle img-30 me-3' src={require(`../../../assets/images/${item.image}`)} alt='Generic placeholder image' />
        <div className='align-self-center'>
          <div>{item.name}</div>
        </div>
      </div>
    ),
    credit: (
      <span className={`f-w-700 font-${item.credit > 5 ? 'success' : 'danger'}`}>
        <i className={`icofont icon-arrow-${item.credit > 5 ? 'up' : 'down'} `}></i> {item.credit}%
      </span>
    ),
    priority: <span className={`badge badge-light-${item.priority === 'High' ? 'primary' : item.priority === 'Low' ? 'success' : item.priority === 'Urgent' ? 'danger' : 'info'}`}>{item.priority}</span>,
  }));

  const [data, setData] = useState(updatedData);

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(
      /* `state` is a React hook that allows you to manage state in a functional
    component. */
      state.selectedRows,
    );
  }, []);

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map((r) => r.title)}?`)) {
      setToggleDelet(!toggleDelet);

      setData(data.filter((item) => (selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true)));
      setSelectedRows('');
    }
  };

  return (
    <Fragment>
      {selectedRows.length !== 0 && (
        <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
          <H4 className='text-muted m-0'>Delet Selected Data..!</H4>
          <Btn color='danger' onClick={() => handleDelete()}>
            Delete
          </Btn>
        </div>
      )}
      <DataTable data={data} columns={tableColumns} striped={true} center={true} pagination selectableRows onSelectedRowsChange={handleRowSelected} clearSelectedRows={toggleDelet} />
    </Fragment>
  );
};
export default DataTableComponent;
